import { startEmailVerification } from "../../apiLoader/campaign";
import { get } from "svelte/store";
import { settingsStore } from "../../stores/settings";
import { getUser } from "../../apiLoader/user";
import { startPoller } from "../poller";

export const initiateEmailVerification = async (): Promise<string> => {
  const campaignKey = get(settingsStore).campaign as string;
  const { email } = await startEmailVerification(campaignKey);
  return email;
};

export const isEmailVerified = async (): Promise<boolean> => {
  const user = await getUser();
  return user?.metadata?.email_verified === user?.email;
};

export const pollEmailVerificationStatus = (callback: () => void) => {
  const delay = 10_000;

  const pollingFunction = async () => {
    try {
      const isVerified = await isEmailVerified();
      return isVerified;
    } catch (error) {
      // we simply ignore the error and keep polling
    }
  };

  return startPoller(
    new Date(),
    { pollingFunction, onPollingSuccess: callback },
    { delay, allowInfinitePolling: true, useExponentialBackoff: false }
  );
};
